import { PROD_ORIGIN } from "./site";

export type RobotsDirective = "index,follow" | "noindex,nofollow";

export type RouteSeo = {
  path: string;
  title: string;
  description: string;
  robots: RobotsDirective;
  prerender: boolean;
};

const INDEX: RobotsDirective = "index,follow";
const NOINDEX: RobotsDirective = "noindex,nofollow";

export const canonical = (path: string) => PROD_ORIGIN + path;

export const SEO_ROUTES: RouteSeo[] = [
  {
    path: "/",
    title:
      "VIVI con Amor y Arte — Agendas y diarios personalizados en Panamá",
    description:
      "Agendas, diarios y merchandising artesanal personalizado. Pedidos corporativos con tu logo y entrega en Panamá.",
    robots: INDEX,
    prerender: true,
  },
  {
    path: "/products",
    title: "Catálogo de agendas y productos personalizados | VIVI",
    description:
      "Explora agendas, diarios y artículos personalizados hechos a mano. Personaliza y compra en línea con entrega en Panamá.",
    robots: INDEX,
    prerender: true,
  },
  {
    path: "/about",
    title: "Sobre VIVI con Amor y Arte | Agenda artesanal hecha a mano",
    description:
      "Conoce la historia detrás de VIVI con Amor y Arte: agendas y diarios artesanales elaborados a mano en Panamá.",
    robots: INDEX,
    prerender: true,
  },
  {
    path: "/privacidad",
    title: "Política de Privacidad | VIVI con Amor y Arte",
    description:
      "Qué datos tratamos en viviconamoryarte.com, para qué los usamos y cómo cambiar o retirar tu consentimiento de cookies y medición.",
    robots: INDEX,
    prerender: true,
  },
  {
    path: "/contact",
    title: "Contacto | VIVI con Amor y Arte",
    description:
      "Escríbenos por WhatsApp o desde el formulario para cotizar tu agenda personalizada o pedido corporativo en Panamá.",
    robots: INDEX,
    prerender: true,
  },
  {
    path: "/personaliza-agenda",
    title: "Personaliza tu agenda | VIVI con Amor y Arte",
    description:
      "Diseña tu agenda artesanal: elige portada, nombre y detalles. Personalización a tu medida con entrega en Panamá.",
    robots: INDEX,
    prerender: true,
  },
  {
    path: "/agenda-builder",
    title: "Crea tu agenda a medida | VIVI con Amor y Arte",
    description:
      "Arma tu agenda personalizada paso a paso y solicita tu cotización. Agenda artesanal hecha a mano en Panamá.",
    robots: INDEX,
    prerender: true,
  },
  {
    path: "/cart",
    title: "Carrito de compras | VIVI con Amor y Arte",
    description: "Revisa los productos de tu carrito antes de finalizar la compra.",
    robots: NOINDEX,
    prerender: false,
  },
  {
    path: "/checkout",
    title: "Finalizar compra | VIVI con Amor y Arte",
    description: "Completa tus datos y el método de pago para finalizar tu compra.",
    robots: NOINDEX,
    prerender: false,
  },
  {
    path: "/login",
    title: "Iniciar sesión | VIVI con Amor y Arte",
    description: "Accede a tu cuenta de VIVI con Amor y Arte.",
    robots: NOINDEX,
    prerender: false,
  },
  {
    path: "/register",
    title: "Crear cuenta | VIVI con Amor y Arte",
    description: "Crea tu cuenta en VIVI con Amor y Arte.",
    robots: NOINDEX,
    prerender: false,
  },
  {
    path: "/forgot-password",
    title: "Recuperar contraseña | VIVI con Amor y Arte",
    description: "Restablece la contraseña de tu cuenta.",
    robots: NOINDEX,
    prerender: false,
  },
  {
    path: "/orders",
    title: "Mis pedidos | VIVI con Amor y Arte",
    description: "Consulta el estado de tus pedidos.",
    robots: NOINDEX,
    prerender: false,
  },
  {
    path: "/security",
    title: "Seguridad de la cuenta | VIVI con Amor y Arte",
    description: "Administra la seguridad de tu cuenta.",
    robots: NOINDEX,
    prerender: false,
  },
];

export const PRERENDER_PATHS = SEO_ROUTES.filter((r) => r.prerender).map(
  (r) => r.path,
);

export const SITEMAP_PATHS = SEO_ROUTES.filter(
  (r) => r.prerender && r.robots === INDEX,
).map((r) => r.path);
